import { ReviewCandidatePullFromJobBoardsComponent } from "./review-candidate-pull-from-job-boards.component";
export var ReviewCandidatePullFromJobBoardsModule = angular
    .module('reviewCandidatePullFromJobBoards', [])
    .component(ReviewCandidatePullFromJobBoardsComponent.selector, ReviewCandidatePullFromJobBoardsComponent.component)
    .name;
//# sourceMappingURL=review-candidate-pull-from-job-boards.module.js.map